import script from "./image-wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./image-wrapper.vue?vue&type=script&setup=true&lang=js"

import "./image-wrapper.vue?vue&type=style&index=0&id=085ab3ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-085ab3ac"]])

export default __exports__